import React from "react";
import { Form } from "@redriver/cinnamon";
import { customersLookup } from "./lookups";

export const CustomersTypeAhead = ({ ...props }) => (
  <Form.TypeAhead {...props} lookup={customersLookup} />
);

export default CustomersTypeAhead;
